<template>
    <div class="save-favorite">
        <div v-if="blnSaveSuccesfull === false && blnSaveFailed === false" class="save-favorite__naming">
            <p v-if="this.favouriteApronID">
                {{$t('productSelector.renameFavorite')}}
            </p>
            <p v-else>
                {{$t('productSelector.nameFavorite')}}
            </p>
            <div>
                <input type="text" name="name" v-model="nameFavorite" :placeholder="$t('productSelector.enterName')" />
                <!--<input type="text" name="name" :value="name"  v-on:input="updateValue($event.target.value)" :placeholder="$t('productSelector.enterName')" />-->

                <navigation-button mode="save" :allow-press="allowSave == true" @button-clicked="saveFavorite()"></navigation-button>

            </div>
        </div>
        <div  v-if="blnSaveSuccesfull" class="save-favorite__succes">
            <p><b-icon-check-circle-fill font-scale="1.5" class="color-green mr-2" /> {{$t('quotation.favoriteSaved')}}</p>
            <router-link v-if="this.$route.name != 'ProductSelector'" :to="{ name: 'ProductSelector', params: { category: 4 } }" class="medium-button blue-gradient mr-4">{{$t('quotation.goToFavorites')}}</router-link>
            <a class="medium-button red-gradient" @click="closeModal()">{{$t('general.close')}}</a>
        </div>
        <div v-if="blnSaveFailed"  class="save-favorite__error">
            <p><b-icon-x-circle-fill font-scale="1.5" class="color-red mr-2" /> {{$t('quotation.favoriteSavingFailed')}}</p>
            <a class="medium-button red-gradient" @click="closeModal()">{{$t('general.close')}}</a>
        </div>

    </div>
</template>

<script>
    import NavigationButton from "@/private/components/UI-elements/NavigationButton.vue";
    import axios from 'axios'
    import Bus from '@/Bus.js';

    export default {
        name: 'SaveFavorite',
        data: function () {

            return {
                nameFavorite: this.name,
                blnSaveSuccesfull: false,
                blnSaveFailed: false,
            }

        },
        components: {
            NavigationButton
        },
        props: {
            name: String,
            sku: String,
            skuSkirt: String,
            favouriteApronID: Number,

        },
        mounted: function () {

        },
        methods: {
            saveFavorite: function () {
                //this.sku === "" ? this.sku = null : this.sku;
                let localSkuSkirt = this.skuSkirt

                if (this.skuSkirt === "" || this.skuSkirt === undefined) {
					localSkuSkirt = null
                }

                // this.favorite.name = this.nameFavorite;
                const favorite = {
                    name: this.nameFavorite,
                    favouriteApronID: this.favouriteApronID,
                    sku: this.sku,
					skuSkirt: localSkuSkirt
                }

                axios.post('/Dashboard/AddOrUpdateFavourite', favorite, {
                    headers: { 'content-type': 'application/json' }
                }).then((response) => {

                    if (response.status == '200' && response.data !== "Error") {
                        this.blnSaveSuccesfull = true;

                        Bus.$emit('favourite-saved', response.data)
                    } else {
                        this.blnSaveFailed = true;
                    }
                })
                    .catch(function (error) {
                        alert(error);
                    }
                    );
            },
            closeModal: function () {
                Bus.$emit('close-modal', this.nameFavorite);
            }
        },
        computed: {
            allowSave: function () {
                if (!this.nameFavorite) {
                    return false
                } else {

                    return true;

                }
            },
        },
        watch: {
            nameFavorite: function (newValue) {
                this.$emit('input', newValue)
            },
            name: function (newValue) {
                this.nameFavorite = newValue
            }
        }
    }
</script>
